// Action types
export const SET_FORM_SELECTION_DATA = "SET_FORM_SELECTION_DATA";
export const CLEAR_FORM_SELECTION_DATA = "CLEAR_FORM_SELECTION_DATA";

// Action creators
export const setFormSelectionData = (data) => ({
  type: SET_FORM_SELECTION_DATA,
  payload: data
});

export const clearFormSelectionData = () => ({
  type: CLEAR_FORM_SELECTION_DATA
});
